import 'ui-core/components/accordion/js/accordion.js';
import Tooltip from '../../tooltip/js/tooltip';

UX.accordion.hideDropBlock = false;
UX.accordion.additionalControls = function () {
    $('.accordion__control').on('keydown touchend', function (e) {
        if (e.type === 'keydown') {
            if (e.keyCode && e.keyCode !== 'Enter' && e.keyCode !== 32) return;
            e.keyCode === 32 && e.preventDefault();
            UX.accordion.on.toggle.single($(this));
        }
    });

    const citedByEl = document.querySelector('.article-section__citedBy');

    if (citedByEl) {
        const citedBySource = citedByEl.dataset.source,
            citedByAccordion = citedByEl.querySelector('.accordion__control'),
            getCitedByContent = () => {
                let toolTipInterval = null;
                const sciteMetricsDropzone = citedByEl.querySelectorAll(
                        '.sciteMetricsDropzone, [data-pb-dropzone="sciteMetricsDropzone"]'
                    ),
                    citedByContentInner = citedByEl.querySelector('.citedByContentInner'),
                    spinner =
                        '<div class="loading-content"><span>loading citations</span><div class="loading"></div></div>',
                    toolTipChecker = () => {
                        const sciteMetrics = citedByEl.querySelector('.scite-metrics .tooltip');
                        if (sciteMetrics) {
                            if (UX.tooltip) {
                                UX.tooltip.reinitialize();
                            } else {
                                UX.tooltip = new Tooltip().initialize();
                            }
                            clearInterval(toolTipInterval);
                        }
                    };

                if (sciteMetricsDropzone.length) {
                    toolTipInterval = setInterval(toolTipChecker, 500);
                }

                if (citedByContentInner && citedByContentInner.textContent === '') {
                    citedByContentInner.innerHTML = spinner;
                    fetch(citedBySource)
                        .then(response => response.text())
                        .then(data => {
                            citedByContentInner.innerHTML = data;
                        });
                }
            };

        citedByAccordion.addEventListener('click', getCitedByContent, {once: true});
    }

    $('.accordion').on('click', '[data-type="ajax"]', function () {
        const $this = $(this),
            $content = $this.parents('.accordion').find('[data-ajax-content]'),
            ajaxData = $content.data('ajax-content'),
            spinner = '<div class="accordion__loading"></div>';

        if (!$content.hasClass('js--loader')) {
            $content.addClass('js--loader').html(spinner);
            $.ajax(ajaxData, {
                success: function (data) {
                    $content.html(data);
                },
            });
        }
    });

    $(document).on('keydown', '.subjects-container .accordion-tabbed__control', function (e) {
        if (e.code !== 'Space' && e.code !== 'Enter') return;
        e.preventDefault();
        UX.accordion.on.toggle.tabbed($(this));
    });

    $('.accordion__control.corrections-label[data-slide-target=".corrections-body"]').on('click', function (e) {
        if (!UX.loader.isMobile) return;
        e.stopImmediatePropagation();
        e.preventDefault();
        const $this = $(this);
        UX.accordion.on.toggle.single($this);
    });
};

UX.accordion.on.toggle.single = function ($this) {
    let $accordionContent = $this.parent().next('.accordion__content').length
            ? $this.parent().next('.accordion__content')
            : $this.next('.accordion__content'),
        $wrapper = $this.closest('.expandable-accordion'),
        state = !($this.attr('aria-expanded') === 'true');

    if (typeof $this.attr('data-content-target') !== 'undefined') {
        let contentTarget = $this.attr('data-content-target');
        $accordionContent = $(contentTarget);
    }

    $accordionContent.stop(true).slideToggle(200, function () {
        if ($this.parents().hasClass('article-accordion')) {
            $('.article-row-left').height('auto');
            UX.accordion.isStickyBody = state;
        }
    });

    $this.toggleClass('js--open');
    $this.attr('aria-expanded', state);
    if ($wrapper.length) UX.accordion.on.checkExpandAll($this, state, $wrapper);
};
